import * as React from 'react';

import { Layout, Button } from 'antd';

import './bv-application-template.scss';

import bvLogo from '../../../assets/images/bv-logo.png';

import BVSidebarNav from '../../components/BVSidebarNav/bv-sidebar-nav';
import BVSignout from '../../components/BVSignout/bv-signout';
import BVCheckoutDrawer from '../../components/BVDrawers/BVCheckoutDrawer/bv-checkout-drawer';
import BVDisclaimerModal from './components/BVDisclaimers/bv-disclaimer-modal';

const {
    Content,
    Header
} = Layout;

const BVApplicationTemplate: React.FunctionComponent = (props) => {
    const [visiblePrivacy, setVisiblePrivacy] = React.useState<boolean>(false);


    const handleClickPrivacy = () => {
        setVisiblePrivacy(true);
    };
    return (
        <Layout className={'bv-application-template'}>
            <BVSidebarNav />

            <Layout>
                <Header className={'template-header'}>
                    <img src={bvLogo} alt={'Bulgari'} />

                    <BVSignout />
                </Header>

                <Content className="template-content">
                    {props.children}
                </Content>

                <BVCheckoutDrawer />
                <Button
                    type="text"
                    onClick={handleClickPrivacy}
                    className='privacy-policy-button'
                >
                    Privacy Policy
                </Button>
            </Layout>
            <BVDisclaimerModal visible={visiblePrivacy} setVisible={setVisiblePrivacy} title='Privacy Policy' text={'#otnotice-26ab4484-ed83-439f-b8f9-948d2e7ccbc8 > div'} />
        </Layout>
    )
};

export default BVApplicationTemplate;